/**
 * Accessibility Enhancer
 * Automatically adds missing or empty alt attributes to images and title attributes to frames
 * Optimized for performance with MutationObserver
 */
(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    defaultImageAlt: 'MoosStudio Image',
    defaultFrameTitle: 'MoosStudio Video',
    debug: false
  };

  /**
   * Process a single image element
   */
  function processImage(img) {
    const currentAlt = img.getAttribute('alt');
    
    // Skip if alt exists AND is not empty (has actual content)
    if (currentAlt && currentAlt.trim() !== '') {
      return;
    }

    // Use title attribute if available, otherwise use default
    const altText = img.getAttribute('title') || CONFIG.defaultImageAlt;
    
    // Only set if we have a meaningful value
    if (altText && altText.trim() !== '') {
      img.setAttribute('alt', altText);

      if (CONFIG.debug) {
        console.log('[A11y] Added alt to image:', altText);
      }
    }
  }

  /**
   * Process a single frame/iframe element
   */
  function processFrame(frame) {
    const currentTitle = frame.getAttribute('title');
    
    // Skip if title exists AND is not empty
    if (currentTitle && currentTitle.trim() !== '') {
      return;
    }

    frame.setAttribute('title', CONFIG.defaultFrameTitle);

    if (CONFIG.debug) {
      console.log('[A11y] Added title to frame:', CONFIG.defaultFrameTitle);
    }
  }

  /**
   * Process all images and frames in a container
   */
  function processElements(container) {
    // Process ALL images (including those with empty alt)
    const images = container.querySelectorAll('img');
    images.forEach(processImage);

    // Process ALL frames/iframes (including those with empty title)
    const frames = container.querySelectorAll('frame, iframe');
    frames.forEach(processFrame);

    if (CONFIG.debug) {
      console.log('[A11y] Scanned:', images.length, 'images,', frames.length, 'frames');
    }
  }

  /**
   * Process a single node (for MutationObserver)
   */
  function processNode(node) {
    // Skip text nodes and non-element nodes
    if (node.nodeType !== Node.ELEMENT_NODE) {
      return;
    }

    // Check if the node itself needs processing
    if (node.tagName === 'IMG') {
      processImage(node);
    } else if (node.tagName === 'FRAME' || node.tagName === 'IFRAME') {
      processFrame(node);
    }

    // Process children if container element
    if (node.children && node.children.length > 0) {
      processElements(node);
    }
  }

  /**
   * Initialize on DOM ready
   */
  function init() {
    // Process existing elements
    processElements(document);

    // Set up MutationObserver for dynamically added elements
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(processNode);
      });
    });

    // Start observing
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });

    if (CONFIG.debug) {
      console.log('[A11y] Accessibility enhancer initialized');
    }

    // Store observer reference for potential cleanup
    window.__a11yObserver = observer;
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM already loaded
    init();
  }

})();